import { RxConversationAPI } from '@driftt/dapper'

export const api = {
  fetchBannedIPs() {
    return RxConversationAPI.get('/bans')
      .checkStatus()
      .map(res => res.response)
  },
  banIP(ip, conversationId) {
    return RxConversationAPI.post('/bans', { ip, conversationId })
      .checkStatus()
      .retryWithBackoff()
  },
  unbanIP(ip, conversationId) {
    return RxConversationAPI.post('/bans/delete', { ip, conversationId })
      .checkStatus()
      .retryWithBackoff()
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/ban/api.js